import { QuestionAnalysis } from "../models/QuestionAnalysis";
import { fetchWithAuthentication } from "../utilities/FetchUtil";

export const fetchQuestionAnalysisList = async (
  interviewId: string,
  setLoading: (newValue: boolean) => void,
) => {
  try {
    setLoading(true);
    const response = await fetchWithAuthentication(
      `/question_analysis?interviewId=${interviewId}`,
      "GET",
      null,
    );
    const data = await response.json();
    if (data.questionAnalysisList.length !== 0) {
      return data.questionAnalysisList.sort(
        (
          a: { questionNum: number },
          b: {
            questionNum: number;
          },
        ) => a.questionNum - b.questionNum,
      );
    }
    return data.questionAnalysisList;
  } catch (error) {
    console.error("Error fetching question analysis list:", error);
  } finally {
    setLoading(false);
  }
};

export const saveQuestionAnalysisList = async (
  method: string,
  questionAnalysisArray: QuestionAnalysis[],
  previousList: QuestionAnalysis[],
  setPreviousList: (updatedList: QuestionAnalysis[]) => void,
) => {
  try {
    if (method === "DELETE") {
      let idsToDelete: string[] = [];
      questionAnalysisArray.forEach((questionAnalysis) => {
        if (questionAnalysis.questionAnalysisId != null) {
          idsToDelete.push(questionAnalysis.questionAnalysisId);
        }
      });
      await fetchWithAuthentication("/question_analysis", method, idsToDelete);
      return;
    }

    const response = await fetchWithAuthentication(
      `/question_analysis`,
      method,
      questionAnalysisArray,
    );

    if (response.ok) {
      const data = await response.json();

      // If we create new entities, we need their IDs
      if (method === "POST") {
        const responseList: QuestionAnalysis[] = data.questionAnalysisList;
        const updatedList = previousList.map((previousItem) => {
          const matchedItem = responseList.find(
            (responseItem) =>
              responseItem.questionNum === previousItem.questionNum,
          );
          return matchedItem
            ? {
                ...previousItem,
                questionAnalysisId: matchedItem.questionAnalysisId,
              }
            : previousItem;
        });

        setPreviousList(updatedList);
      }
    } else {
      console.error("Failed to save data:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
  }
};
